import { Theme } from '@mui/material';

export const instructionStyles = (theme: Theme) => ({
  instructionContent: {
    width: '100%',
    height: '100%',
    overflow: 'auto',
    padding: theme.spacing(2),
    color: theme.palette.text.primary,
    backgroundColor: 'transparent',
    '& .header-section': {
      marginBottom: theme.spacing(3),
    },
    '& .theme-header': {
      color: theme.palette.text.primary,
      backgroundColor: 'transparent',
      margin: theme.spacing(2, 0),
    },
    '& .theme-text': {
      color: theme.palette.text.primary,
    },
    '& .theme-table': {
      width: '100%',
      borderCollapse: 'collapse',
      marginBottom: theme.spacing(3),
      '& th, & td': {
        padding: theme.spacing(1),
        border: `1px solid ${theme.palette.divider}`,
        color: theme.palette.text.primary,
      },
      '& .theme-table-header': {
        backgroundColor:
          theme.palette.mode === 'dark' ? theme.palette.grey[800] : theme.palette.grey[100],
        '& th': {
          fontWeight: 600,
          color: theme.palette.text.primary,
        },
      },
      '& tbody tr:nth-of-type(odd)': {
        backgroundColor:
          theme.palette.mode === 'dark' ? theme.palette.grey[900] : theme.palette.grey[50],
      },
      '& tbody tr:nth-of-type(even)': {
        backgroundColor: 'transparent',
      },
    },
    '& blockquote': {
      borderLeft: `4px solid ${theme.palette.primary.main}`,
      margin: theme.spacing(2, 0),
      padding: theme.spacing(1, 2),
      backgroundColor:
        theme.palette.mode === 'dark' ? theme.palette.grey[900] : theme.palette.grey[50],
    },
    '& a': {
      color: theme.palette.primary.main,
      textDecoration: 'none',
      '&:hover': {
        textDecoration: 'underline',
      },
    },
    '& strong, & em': {
      color: 'inherit',
    },
  },
  instructionButton: {
    width: '100%',
    textAlign: 'left',
    whiteSpace: 'normal',
    wordWrap: 'break-word',
    fontSize: {
      xs: '0.75rem',
      sm: '0.875rem',
      md: '1rem',
    },
    lineHeight: 1.2,
    padding: theme.spacing(1, 2),
    '& .MuiButton-label': {
      justifyContent: 'flex-start',
    },
  },
});
